export var StartingEquipmentRuleTypeEnum;
(function (StartingEquipmentRuleTypeEnum) {
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["WEAPON"] = 1] = "WEAPON";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["ARMOR"] = 2] = "ARMOR";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["GEAR"] = 3] = "GEAR";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["WEAPON_TYPE"] = 4] = "WEAPON_TYPE";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["GEAR_TYPE"] = 5] = "GEAR_TYPE";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["ARMOR_TYPE"] = 6] = "ARMOR_TYPE";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["CUSTOM"] = 7] = "CUSTOM";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["GOLD_VALUE"] = 8] = "GOLD_VALUE";
    StartingEquipmentRuleTypeEnum[StartingEquipmentRuleTypeEnum["INSTRUCTION"] = 9] = "INSTRUCTION";
})(StartingEquipmentRuleTypeEnum || (StartingEquipmentRuleTypeEnum = {}));
